export default theme => ({
  /// ////// Format Mobile //////////
  hr: {
    borderColor: theme.listeProducteur.hrColor,
    margin: '0px -15px 15px'
  },
  colProd: {
    textAlign: 'center'
  },
  prodContainer: {
    backgroundColor: 'white',
    margin: '-15px -15px 0 -15px',
    padding: '15px 15px 0px'
  },

  /// ////// Format Desktop /////////
  texteResultatsAutreFormat: {
    fontWeight: theme.regular,
    fontSize: theme.tailleGrandTexte,
    color: 'white',
    marginTop: '10px'
  },
  divProd: {
    backgroundColor: 'white',
    margin: '30px 15px 15px 15px'
  },
  colProdAF: {
    textAlign: 'center'
  },
  buttonProducteur: {
    margin: '15px 0'
  },

  /// ////// Style pour les deux formats //////////
  pagination: {
    padding: '15px 0px'
  },
  hrPub: {
    borderColor: theme.producteur.hrColor,
    margin: 0
  },
  pub: {
    width: '100%'
  }
})
